var tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var players = document.querySelectorAll('.shopify-you-tube-video');
function onYouTubeIframeAPIReady() {
  players.forEach((videoElement) => {
    let player = new YT.Player(videoElement, {
      events: {
        onReady: onPlayerReady,
      },
    });
  });
}

function onPlayerReady(event) {
  var player = event.target;
  player.g
    .closest('.video-with-content-accordian')
    .querySelectorAll('.featured-details-control-icon')
    .forEach((playPauseIcon) => {
      playPauseIcon.addEventListener('click', () => {
        if (player.getPlayerState() === YT.PlayerState.PLAYING) {
          player.pauseVideo();
          document
            .querySelector('.featured-details-play-icon')
            .classList.remove('hidden');
          document
            .querySelector('.featured-details-pause-icon')
            .classList.add('hidden');
        } else {
          player.playVideo();
          document
            .querySelector('.featured-details-play-icon')
            .classList.add('hidden');
          document
            .querySelector('.featured-details-pause-icon')
            .classList.remove('hidden');
        }
      });
    });
}
